<template>
    <div v-if="isPopupsEnabled">
        <header v-if="environmentDisplayText != undefined">
            <section class="top" style="background: repeating-linear-gradient(45deg,#000,#000 10px,#f2ec25 10px,#f2ec25 20px); height: 35px;" onclick="this.parentNode.style.display = 'none';">
                <div style="background: #f2ec25; width: 100%; color: #000; font-family: Oswald, sans-serif; font-weight: 400; text-align: center; ">
                    <b>{{environmentDisplayText}}</b>
                </div>
            </section>
        </header>
        <header>
            <section class="top">
                <div class="nexteer-branding">
                    <router-link to="/"><img src="../public/nexteer-logo.svg" /></router-link>
                    <img src="../public/ncas-logo.svg" />
                </div>
                <div>
                    <nav>
                        <router-link to="/"><i class="fas fa-home"></i> Home </router-link>
                        <a href="https://ncas.nexteer.app"><i class="fas fa-tachometer-alt"></i> Dashboard</a>
                        <router-link to="/compare"><i class="fas fa-arrow-right-arrow-left"></i> Compare</router-link>
                        <router-link :to="routes.COMPONENT_WALK"><i class="fa-solid fa-code-compare"></i> {{reportNames.COMPONENT_WALK}}</router-link>
                        <a v-on:click="viewBookmarks"><i class="fas fa-bookmark"></i> Bookmarks</a>
                    </nav>
                </div>
                <div class="user-name-container">
                    <span class="user-name">{{name}}</span>
                </div>
            </section>
        </header>

        <router-view @UpdateBookmarks="updateBookmarks" />
    </div>

    <div class="popup-container" v-if="!isPopupsEnabled">
        <p>You must have pop-ups enabled to use this app. Please follow the below instructions, then refresh your page.</p>

        <img src="../public/allowpopup.png" />
    </div>
</template>

<script>
    import { Sort, Page, Toolbar, Search, Edit } from "@syncfusion/ej2-vue-grids";
    import Session from "./modules/Session";
    import Bookmark from "./modules/Bookmark";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import Config from './modules/Config';
    import { Routes as routes, ReportNames as reportNames } from "./modules/Constants";

    export default {
        name: 'App',
        components: {
        },
        data() {
            return {
                bookmarks: [],
                name: null,
                isPopupsEnabled: false,
                showCompareLink: false,
                environmentDisplayText: undefined, 
                routes,
                reportNames
            };
        },
        provide: {
            grid: [Sort, Page, Toolbar, Search, Edit]
        },
        methods: {
            updateBookmarks: function () {
                this.bookmarks = Bookmark.GetBookmarks();
            },
            viewBookmarks: function () {
                let html = document.createElement('div');

                this.bookmarks.sort((a, b) => ('' + a.displayName).localeCompare(b.displayName)).forEach(bookmark => {
                    html.innerHTML += `<div class="bookmarked-item"><a href="${bookmark.path}"><i class="fas fa-bookmark"></i> ${bookmark.displayName} </a></div>`
                })

                if (this.bookmarks.length === 0) {
                    html.innerHTML = '<div>You currently have no reports bookmarked</div>';
                }

                DialogUtility.alert({
                    title: `My Bookmarks`,
                    content: html,
                    okButton: { text: 'Close', click: function () { this.hide() } },
                    showCloseIcon: false,
                    closeOnEscape: false,
                    animationSettings: { effect: 'Zoom' }
                });
            }
        },
        mounted() {
            this.updateBookmarks();
            this.environmentDisplayText = Config.Provider("environmentDisplayText");

            let newWin = window.open("/popup");

            if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
                this.isPopupsEnabled = false;
            } else {
                newWin.close();
                this.isPopupsEnabled = true;
            }

            this.name = Session.GetDisplayName();
            this.showCompareLink = Config.Provider("showCompareLink");
        }
    }
</script>

<style>
    @import '../node_modules/@syncfusion/ej2-base/styles/bootstrap.css';
    @import "../node_modules/@syncfusion/ej2-vue-inputs/styles/bootstrap.css";
    @import "../node_modules/@syncfusion/ej2-vue-notifications/styles/bootstrap.css";
    @import '../node_modules/@syncfusion/ej2-vue-dropdowns/styles/bootstrap.css';
    @import '../node_modules/@syncfusion/ej2-vue-grids/styles/bootstrap.css';
    @import '../node_modules/@syncfusion/ej2-vue-popups/styles/bootstrap.css';
    @import "../node_modules/@syncfusion/ej2-vue-buttons/styles/bootstrap.css";
    @import "../node_modules/@syncfusion/ej2-vue-navigations/styles/bootstrap.css";
    @import "../node_modules/@syncfusion/ej2-vue-spreadsheet/styles/bootstrap.css";
    @import "../node_modules/@syncfusion/ej2-vue-lists/styles/material.css";

    #app {
        height: 100vh;
    }

    body {
        margin:0;
        padding:0;
    }

    header section.bottom {
        background-color: #e51937;
        min-height: 70px;
        height: 70px;
        max-height: 70px;
        /*-ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-line-pack: stretch;*/
        margin-bottom: 10px;
        /*        display: -ms-flexbox;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-align: center;
        -ms-flex-line-pack: center;*/
        display: flex;
        align-items: center;
    }

        header section.bottom .bottom-title {
            align-content: center;
            background-color: #d41e39;
            padding-left: .5rem;
            margin-right: 4.375rem;
            position: relative;
            width: 150px;
            height: 100%;
        }

        header section.bottom nav {
            padding-left: .5rem;
            margin-right: 4.375rem;
            position: relative;
        }

            header section.bottom nav a {
                color: white;
                font-family: Oswald,"sans-serif";
                font-weight: 400;
                outline: transparent;
                position: relative;
                font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
                -webkit-font-smoothing: antialiased;
                font-size: 1rem;
                font-weight: 400;
                box-sizing: border-box;
                border: 1px solid transparent;
                display: inline-block;
                text-decoration: none;
                text-align: center;
                cursor: pointer;
                vertical-align: top;
                padding: 0px 4px;
                border-radius: 0px;
                min-width: 40px;
                user-select: none;
            }

        header section.bottom .bottom-title p {
            color: #fff;
            font-family: Oswald,sans-serif;
            font-weight: 700;
            font-size: 0.96rem;
            text-transform: uppercase;
            line-height: 65px;
        }

            header section.bottom .bottom-title:after {
                content: "";
                display: block;
                position: absolute;
                z-index: 2;
                pointer-events: none;
                border: 48.9853px solid transparent;
                right: -48.4353px;
                top: -48.4353px;
                border-left-color: #d41e39;
                -webkit-transform: rotate(-135deg);
                -ms-transform: rotate(-135deg);
                transform: rotate(-135deg);
            }

    header section.top {
        width: 100%;
        padding: 0;
        background-color: #f4f4f4;
        display: flex;
        height: 100%;
        flex-wrap: nowrap;
        align-items: center;
    }

    .nexteer-branding {
        min-height: 50px;
        height: 50px;
        max-height: 50px;
        width: 224px;
        padding: 0 8px;
        margin-right: 50px;
        background-color: #fff;
        position: relative;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        -ms-flex-pack: stretch;
        justify-content: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        -ms-flex-line-pack: stretch;
        align-content: stretch;
    }

    .nexteer-branding:after {
        content: "";
        display: block;
        position: absolute;
        z-index: 2;
        pointer-events: none;
        border: 34.9895px solid transparent;
        right: -34.4395px;
        top: -34.4395px;
        border-left-color: #fff;
        -webkit-transform: rotate(-135deg);
        -ms-transform: rotate(-135deg);
        transform: rotate(-135deg);
    }

        .nexteer-branding img {
            height: 32px;
            margin: 8px 0;
        }

    header section.top .user-name-container {
        height: 50px;
        display: inline-flex;
        flex: auto;
        flex-direction: row-reverse;
        align-items: center;
        padding-right: 10px;
    }

    header section.top nav a, header section.top .user-name-container span.user-name {
        font-family: Oswald,"sans-serif";
        font-weight: 400;
        font-size: .875rem;
        color: #666;
        outline: transparent;
        position: relative;
        font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
        -webkit-font-smoothing: antialiased;
        font-size: 14px;
        font-weight: 400;
        box-sizing: border-box;
        border: 1px solid transparent;
        display: inline-block;
        text-decoration: none;
        text-align: center;
        cursor: pointer;
        vertical-align: top;
        padding: 0px 4px;
        border-radius: 0px;
        min-width: 40px;
        background-color: rgb(244, 244, 244);
        color: rgb(51, 51, 51);
        user-select: none;
    }

        header section.top nav a:hover {
            background-color: transparent;
            color: #e51937;
        }

    .e-input-group, .e-input-group.e-control-wrapper{
        background-color: white;
    }

    .popup-container {
        font-family: Helvetica Neue,Helvetica,Arial,sans-serif,-apple-system,BlinkMacSystemFont;
        font-size: 15px;
        font-weight: 400;
        background-color: #fff;
        color: #333;
        display: flex;
        align-content: center;
        padding: 30px 0;
        flex-direction: column;
        align-items: center;
    }

    .popup-container img {
        margin: 30px 0 0 0;
    }

    .e-toast-info .e-toast {
        background-color: #ededed !important;
    }

    .e-toast-error .e-toast {
        background-color: #e51937 !important;
        color: white !important;
    }

    .e-toast-error .e-toast .e-toast-message .e-toast-title {
        color: white !important;
    }

    .e-toast-error .e-toast .e-toast-message .e-toast-content {
        color: white !important;
    }

    .flex-container {
        display: flex;
    }

    .flex-child {
        flex: 1;
    }

    .hidden{
        display: none;
    }

    .bookmarked-item a {
        color: black;
        font-family: Oswald,"sans-serif";
        font-weight: 400;
        outline: transparent;
        position: relative;
        font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
        -webkit-font-smoothing: antialiased;
        font-weight: 400;
        box-sizing: border-box;
        border: 1px solid transparent;
        display: inline-block;
        text-decoration: none;
        text-align: left;
        cursor: pointer;
        vertical-align: top;
        padding: 0px 4px;
        border-radius: 0px;
        min-width: 40px;
        user-select: none;
    }

    .bookmarked-item a:hover{
        color: red;
    }

    .e-grid .e-toolbar .e-btn {
        background-color: #317ab9;
    }
    .e-tbar-btn-text {
        color: #fff !important;
    }

    .e-toolbar .e-tbar-btn.e-btn .e-icons {
        color: #fff !important;
    }

    .e-grid .e-groupcaption {
        background-color: #d3d3d3;
    }

    .e-grid .e-recordplusexpand,
    .e-grid .e-recordpluscollapse {
        background-color: #d3d3d3;
    }

    .e-grid .e-indentcell {
        background-color: #d3d3d3;
    }
</style>